import { Flex } from '@chakra-ui/react';
import Editor from '@monaco-editor/react';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { MonacoType } from 'types/global';

import { defaultEditorOptions, defaultTheme, lightTheme } from './common';

export const ReceivableValuationRateFormulaEditor: React.FC<{
  value: string;
  onChange: (
    value: string | undefined,
    ev: MonacoType.editor.IModelContentChangedEvent,
  ) => void;
  onValidate?: (markers: MonacoType.editor.IMarker[]) => void;
  operationMode?: CreditAgreement.OperationMode;
}> = ({ value, onChange, onValidate, operationMode }) => {
  const theme = operationMode === 'lender' ? lightTheme : defaultTheme;

  return (
    <Flex width="100%" resize="both" overflow="auto" height="15vh">
      <Editor
        language="formula-receivableValuationRate"
        onChange={onChange}
        onValidate={onValidate}
        options={defaultEditorOptions}
        theme={theme}
        value={value}
      />
    </Flex>
  );
};
